import * as React from 'react';

interface OwnProps {
  text?: string;
}

type Props = OwnProps;

export const PlainText: React.FC<Props> = (props) => {
  const {text = ''} = props;
  return <span>{text}</span>;
};

PlainText.displayName = 'PlainText';
